import { ReactNode } from "react";
import { Form } from "antd";
import { Rule } from "antd/es/form";

/**
 * A title field bound to one locale of a locale map, with the inactive locales kept mounted so
 * their validation still runs while hidden.
 *
 * @param {string} name - the form field holding the locale map
 * @param {string[]} locales - every enabled locale
 * @param {string} activeLocale - the locale currently shown
 * @param {(locale: string) => ReactNode} children - renders the input for a locale
 * @returns {JSX.Element} one Form.Item per locale, all but the active one hidden
 */
export default function LocalizedTitleField({
  name,
  locales,
  activeLocale,
  label,
  className,
  rulesForLocale,
  dataLengthForLocale,
  children,
}: {
  name: string;
  locales: string[];
  activeLocale: string;
  label: string;
  className?: string;
  rulesForLocale?: (locale: string) => Rule[];
  dataLengthForLocale?: (locale: string) => string | undefined;
  children: (locale: string) => ReactNode;
}) {
  return (
    <>
      {locales.map((locale) => (
        <div key={locale} hidden={locale !== activeLocale}>
          <Form.Item
            className={className}
            name={[name, locale]}
            label={label}
            data-length={dataLengthForLocale?.(locale)}
            rules={rulesForLocale?.(locale)}
          >
            {children(locale)}
          </Form.Item>
        </div>
      ))}
    </>
  );
}
